/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EstimatedBasicCostDto } from '../../models/estimated-basic-cost-dto';

export interface GetEstimatedBasicCost$Params {
  id: string;
}

export function getEstimatedBasicCost(http: HttpClient, rootUrl: string, params: GetEstimatedBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedBasicCostDto>> {
  const rb = new RequestBuilder(rootUrl, getEstimatedBasicCost.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EstimatedBasicCostDto>;
    })
  );
}

getEstimatedBasicCost.PATH = '/v0/estimatedBasicCost/{id}';
